import GATSBY_COMPILED_MDX from "/home/develop/pxplanding/data/about/solution.mdx";
import React from "react";
import MainLayout from "../components/main-layout";
import SEO from "../components/seo";
import {Container, Content} from "./../components/container/container";
import {Bar} from "../components/roles-bar";
import * as styles from "./about.module.css";
function AboutPage(_ref) {
  let {pageContext, children} = _ref;
  return React.createElement(MainLayout, {
    mode: "about",
    HasFooter: true
  }, React.createElement("div", {
    style: {
      flex: 1
    },
    className: styles.container
  }, React.createElement(Bar, {
    selected: pageContext.title,
    text: "Select About",
    position: "left",
    style: {
      marginLeft: 40,
      marginTop: 4
    },
    mode: "customer",
    goBack: false,
    links: pageContext.links.map(x => ({
      name: x.title,
      slug: "/about/" + x.slug
    })),
    simple: true,
    reverseColoring: true
  }), React.createElement(Container, {
    title: React.createElement("h1", {
      className: "header"
    }, pageContext.title),
    showTitle: false,
    className: styles.aboutContainer,
    containerClassName: styles.aboutContainersContainer,
    showTopBar: false,
    showBack: false
  }, React.createElement(Content, {
    className: styles.aboutContent
  }, children))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(AboutPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref2 => {
  var _pageContext$frontmat, _pageContext$frontmat2;
  let {pageContext} = _ref2;
  return React.createElement(SEO, {
    meta: [{
      name: "keywords",
      content: (_pageContext$frontmat = pageContext.frontmatter) === null || _pageContext$frontmat === void 0 ? void 0 : (_pageContext$frontmat2 = _pageContext$frontmat.keywords) === null || _pageContext$frontmat2 === void 0 ? void 0 : _pageContext$frontmat2.join(",")
    }],
    title: pageContext.title,
    description: pageContext.description
  });
};
